var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDkFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#c8102e",
  d: "M0 0h37v28H0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 4,
  d: "M0 14h37M14 0v28"
})));
export default SvgDkFlag;